module.exports = __webpack_public_path__ + "img/standard.7edadbe7.png";